import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumToRadioButton = _resolveComponent("EnumToRadioButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ObjectEqualToUpper")), 1),
    _createVNode(_component_EnumToRadioButton, {
      modelValue: _ctx.triggerOrActionToAdd.lightState,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerOrActionToAdd.lightState = $event)),
      enum: _ctx.SceneLightState
    }, null, 8, ["modelValue", "enum"])
  ]))
}